import { Link, useLocation } from "react-router-dom";
import { Rss } from "lucide-react";
import { getDocsByCategory } from "@/content/docs";

/**
 * Sticky sidebar listing all docs grouped by category.
 * Shared between Docs index and DocArticle pages.
 */
export default function DocsSidebar({ activeSlug }) {
  const groups = getDocsByCategory();
  const location = useLocation();
  const changelogActive = activeSlug === "changelog" || location.pathname === "/docs/changelog";

  return (
    <aside className="lg:sticky lg:top-24 lg:max-h-[calc(100vh-7rem)] lg:overflow-y-auto" data-testid="docs-sidebar">
      <div className="font-mono-data text-[10px] uppercase tracking-widest text-muted-foreground mb-4">
        // help docs
      </div>
      <nav className="space-y-7">
        {groups.map((g) => (
          <div key={g.id}>
            <div className="text-xs font-semibold tracking-tight uppercase text-foreground/70 mb-2">
              {g.label}
            </div>
            <ul className="space-y-1">
              {g.items.map((d) => {
                const isActive =
                  activeSlug === d.slug ||
                  location.pathname === `/docs/${d.slug}`;
                return (
                  <li key={d.slug}>
                    <Link
                      to={`/docs/${d.slug}`}
                      data-testid={`docs-sidebar-link-${d.slug}`}
                      className={
                        "block text-sm py-1.5 pl-3 border-l-2 transition-colors " +
                        (isActive
                          ? "border-foreground text-foreground font-medium"
                          : "border-transparent text-muted-foreground hover:text-foreground hover:border-border")
                      }
                    >
                      {d.title}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}

        {/* Changelog (auto-generated from /blog) */}
        <div>
          <div className="text-xs font-semibold tracking-tight uppercase text-foreground/70 mb-2">
            Release notes
          </div>
          <ul className="space-y-1">
            <li>
              <Link
                to="/docs/changelog"
                data-testid="docs-sidebar-link-changelog"
                className={
                  "flex items-center gap-2 text-sm py-1.5 pl-3 border-l-2 transition-colors " +
                  (changelogActive
                    ? "border-foreground text-foreground font-medium"
                    : "border-transparent text-muted-foreground hover:text-foreground hover:border-border")
                }
              >
                <Rss className="w-3 h-3" /> What&apos;s new
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </aside>
  );
}
